import atlassian from './atlassian.png';
import bamboohr from './bamboohr.png';
import box from './box.png';
import hibob from './hibob.png';
import docusign from './docusign.png';
import dropbox from './dropbox.png';
import egnyte from './egnyte.png';
import employmenthero from './employmenthero.png';
import github from './github.png';
import googlews from './googlews.png';
import lucidchart from './lucidchart.png';
import manageengine from './manageengine.png';
import microsoft365 from './microsoft365.png';
import monday from './monday.png';
import okta from './okta.png';
import sagepeople from './sagepeople.png';
import salesforce from './salesforce.png';
import sendgrid from './sendgrid.png';
import slack from './slack.png';
import smartsheet from './smartsheet.png';
import xero from './xero.png';
import zendesk from './zendesk.png';
import zoom from './zoom.png';

export const saasLogos: Record<string, string> = {
  atlassian,
  box,
  bamboohr,
  docusign,
  dropbox,
  egnyte,
  employmenthero,
  github,
  googlews,
  hibob,
  lucidchart,
  manageengine,
  microsoft365,
  monday,
  okta,
  sagepeople,
  salesforce,
  slack,
  smartsheet,
  xero,
  zendesk,
  zoom,
  sendgrid,
};
